import React, { useState, useEffect } from "react";
import { Term } from "./components/terms";
import { Footer } from "./components/footer";

import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Terms = () => {
  return (
    <>
      <Term />
      <Footer />
    </>
  );
};

export default Terms;
